export default __webpack_public_path__ + "static/media/adult.a58cb7c2.png";